// extracted by mini-css-extract-plugin
export var errorsContainer = "_v8-1";
export var link = "_v8-0";